<div class="modal-detail-container hide-modal-detail">
    <div class="modal-detail">
        <ng-content></ng-content>
    </div>
    <div class="modal-detail-mask"></div>
</div>
